import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { updateSaleDepartmentURL, getSaleDepartmentURL } from '../api';
import moment from 'jalali-moment'
import { ENC1 } from "../helpers/mmg";

// initial state
export const initialState = {
  loading: false,
  roles : ['Optician','Personnel','FinancialPersonnel'],
  boxMessage : '',
  boxType : 0,//1 Error , 2 Success, 3 Info
  error: false,
};

// our slice
const saleDepartmentSlice = createSlice({
  name: "saleDepartment",
  initialState,
  reducers: {
    setSaleDepartmentLoading: (state) => {
      state.loading = true;
    },
    setSaleDepartmentLoadingFalse: (state) => {
      state.loading = false;
    },
    setSaleDepartmentData: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.title = payload.Title;
      state.code = payload.Code;
      state.members.push(...payload.SaleDepartmentMembers);
      state.hasMore = false;
    },
    setSaleDepartmentError: (state) => {
      state.error = true;
      state.loading = false;
    },
    addItem: (state, { payload }) => {
      var newRowId = state.members.length + 1;
      var newMember = { RowID : newRowId , MemberUserId : payload.memberUserId, MemberAlias : payload.memberAlias, IsActive : payload.isActive , Password : payload.password , RoleName : payload.roleName, NeedPasswordChange : true , isActive : true , MemberDescription : payload.memberDescription , UserName : payload.userName , IsHead : false };
      state.members.push(newMember);

    },
    updateItem: (state, { payload }) => {
      if (state.members.find(e => e.RowID.toString() === payload.rowID.toString())) {
          /* ItemExist */
          //if(payload.addQuantityToCurrent ? parseFloat(state.items.find(e => e.RowId.toString() === state.selectedRowId.toString()).Quantity) + parseFloat(payload.selectedQuantity) : parseFloat(payload.selectedQuantity) >= 0){
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).MemberAlias = payload.memberAlias;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).MemberDescription = payload.memberDescription;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).IsActive = payload.isActive;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).Password = payload.password;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).RoleName = payload.roleName;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).NeedPasswordChange = payload.needPasswordChange;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).UserName = payload.userName;
            state.members.find(e => e.RowID.toString() === payload.rowID.toString()).AllowedMachines = payload.allowedMachines;
          //}
        }
    },
    deleteItem: (state, { payload }) => {

      if (!(payload.ID > 0) && state.members.find(e => e.RowID.toString() === payload.rowID.toString())) {
        /* ItemExist */
        console.log(" ItemExist");
        state.members = state.members.filter(e => e.RowID.toString() !== payload.rowID.toString());
        console.log(state.members);
        for(var i = 0 ; i < state.members.length ; i++){
          state.members[i].RowId = i + 1;
        }
      }
    },
    setSaleDepartmentResultBox: (state, { payload }) => {

      console.log("setSTOrderResultBox");
      console.log(payload);
      state.boxMessage = payload.message;
      state.boxType = payload.type;//1 Error , 2 Success, 3 Info
    },
    resetSaleDepartmentResultBox: (state, { payload }) => {
      state.boxMessage = ''
      state.boxType = 0;//1 Error , 2 Success, 3 Info
    },
    clearSaleDepartment: (state) => {
      state.loading = false;
      state.error = false;
      state.title = "";
      state.code = "";
      state.members = [];
      state.hasMore = false;
      state.boxMessage = '';
      state.boxType = 0;//1 Error , 2 Success, 3 Info
      state.currentPageIndex = 0;
    },
  },
});

// export the actions
export const { setSaleDepartmentLoading, 
  setSaleDepartmentData,
  setSaleDepartmentError,
  clearSaleDepartment,deleteItem,updateItem,addItem,setSaleDepartmentLoadingFalse,setSaleDepartmentResultBox,resetSaleDepartmentResultBox
} = saleDepartmentSlice.actions;


// export the default reducer
export default saleDepartmentSlice.reducer;


// fetch all items
export function fetchSaleDepartment(input) {
  return async (dispatch) => {
    console.log("input");
    console.log(input);

    //if(input.pageindex === 0)
      dispatch(clearSaleDepartment());

      dispatch(setSaleDepartmentLoading());
      await axios.post(getSaleDepartmentURL()+'?username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setSaleDepartmentData(response.data));
      }).catch(function (err) {
        dispatch(setSaleDepartmentError());
      }).finally(()=> {

      });
  
  };
}

export function submitSaleDepartment(input) {
  return async (dispatch) => {
    
    //console.log("The Input");
    //console.log(input);
    dispatch(setSaleDepartmentLoading());
    let SaleDepartmentMembers = [];
    
    for(var i = 0 ;  i < input.saleDepartment.members.length ; i++){

        var item = input.saleDepartment.members[i];
       
          SaleDepartmentMembers.push(
            {
              ID : item.ID,
              RowID : 0,
              MemberUserId : item.MemberUserId,
              MemberAlias : item.MemberAlias,
              MemberDescription : item.MemberDescription,
              IsActive : item.IsActive,
              UserName : item.UserName,
              Password : item.NeedPasswordChange ? ENC1(item.Password) : '',
              RoleName : item.RoleName,
              NeedPasswordChange : item.NeedPasswordChange,
              IsHead : item.IsHead,
              AllowedMachines : item.AllowedMachines
            });
    }

    let SaleDepartmentDataModel = {};
    SaleDepartmentDataModel = {
      SaleDepartmentMembers : SaleDepartmentMembers,
      Title: input.saleDepartment.title,
      Code : input.saleDepartment.code,
      HeadDLCode : input.authUser.dlCode
    }

    var data = JSON.stringify(SaleDepartmentDataModel);

    console.log("data");
    console.log(data);

    var config = {
      method: 'post',
      url: `${updateSaleDepartmentURL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    //console.log(data);
    await axios(config).then(function (response) {
       
        //console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          console.log("Success");
          dispatch(setSaleDepartmentResultBox({message : response.data.Message , type : 2}));
          
        }else{
          dispatch(setSaleDepartmentResultBox({message : response.data.Message , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setSaleDepartmentResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setSaleDepartmentLoadingFalse());
      });
  
  };
}


